export default __webpack_public_path__ + "static/banner-c92b8b6ec2ba5d6dcccb5ec4ad58921a.jpg";